import { formatDistanceToNow } from 'date-fns';
export function timeAgo(timestamp) {
    return formatDistanceToNow(new Date(timestamp), {
        addSuffix: true
    });
}
